import React from 'react';
import { DynamicPageCustomElementRecord } from '~/config/generated/graphql';
import CustomerService from '~/App/shared/components/CustomerService';
import CookieDeclarationInjection from '~/App/shared/components/CookieDeclarationInjection';
import ElectricCarGrantForm from '~/App/shared/components/ElectricCarGrantForm';
import CarRaceGame from '~/App/views/DynamicPage/components/CarRaceGame';

type Props = {
  record: DynamicPageCustomElementRecord;
};

const DynamicPageCustomElemDispatcher = ({ record }: Props) => {
  const { usageType } = record;

  switch (usageType) {
    case 'customerService':
      return <CustomerService />;
    case 'cookieDeclarationTable':
      return <CookieDeclarationInjection />;
    case 'electricCarGrantForm':
      return <ElectricCarGrantForm />;
    case 'storaBilracet':
      return <CarRaceGame />;
    default:
      return null;
  }
};

export default DynamicPageCustomElemDispatcher;
